<template>
  <b-modal
    v-model="localShow"
    title="Exportar todos os procedimentos"
    centered
    hide-footer
    @hidden="handleHidden"
  >
    <ValidationObserver ref="observerExportarProcedimentos">
      <div class="row">
        <div class="col-md-6">
          <validation-provider v-slot="{ errors }" rules="required|min:4|max:4">
            <label class="mb-1">Ano</label>
            <input
              v-model="form.ano"
              type="text"
              class="form-control"
              placeholder="Ex.: 2026"
              maxlength="4"
              inputmode="numeric"
            />
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <label class="mb-1">Mês</label>
            <vue-select
              v-model="form.mes"
              :options="monthOptions"
              label="label"
              placeholder="Selecione o mês"
              :clearable="false"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
      </div>
      <div class="modal-actions d-flex justify-content-end mt-4">
        <button
          type="button"
          class="btn btn-padrao mr-2"
          :disabled="loading"
          @click="localShow = false"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-padrao"
          :disabled="loading"
          @click="confirmar()"
        >
          Confirmar
          <b-spinner small variant="light" v-if="loading" class="ml-2" />
        </button>
      </div>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()

export default {
  name: 'ModalExportarProcedimentos',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        ano: String(new Date().getFullYear()),
        mes: null,
      },
      monthOptions: [
        { label: 'Janeiro', value: 1 },
        { label: 'Fevereiro', value: 2 },
        { label: 'Março', value: 3 },
        { label: 'Abril', value: 4 },
        { label: 'Maio', value: 5 },
        { label: 'Junho', value: 6 },
        { label: 'Julho', value: 7 },
        { label: 'Agosto', value: 8 },
        { label: 'Setembro', value: 9 },
        { label: 'Outubro', value: 10 },
        { label: 'Novembro', value: 11 },
        { label: 'Dezembro', value: 12 },
      ],
    }
  },
  computed: {
    localShow: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      },
    },
  },
  methods: {
    /**
     * Reseta os campos do formulário do modal
     */
    resetForm() {
      this.form.ano = String(new Date().getFullYear())
      this.form.mes = null
      if (this.$refs.observerExportarProcedimentos) {
        this.$refs.observerExportarProcedimentos.reset()
      }
    },

    /**
     * Trata o fechamento do modal e limpa o formulário
     */
    handleHidden() {
      this.resetForm()
      this.$emit('update:show', false)
    },

    /**
     * Valida o formulário e executa a exportação
     */
    async confirmar() {
      const isValid = await this.$refs.observerExportarProcedimentos.validate()
      if (!isValid) return

      this.loading = true
      try {
        await this.onConfirm({
          ano: Number(this.form.ano),
          mes: this.form.mes.value,
        })
        this.localShow = false
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.error {
  color: #dc3545;
  font-size: 0.875rem;
}

.modal-actions .btn-padrao {
  height: 35px;
  border-radius: 32px;
  background-color: #0fafd7 !important;
  border: 1px solid transparent !important;
  color: #fff !important;
  font-weight: 700;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  font-size: 14px;
  padding: 0 15px;
}

.modal-actions .btn-padrao:hover,
.modal-actions .btn-padrao:focus,
.modal-actions .btn-padrao:active,
.modal-actions .btn-padrao:focus-visible {
  background-color: #0fafd7 !important;
  border-color: transparent !important;
  color: #fff !important;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  outline: none !important;
}

.modal-actions .btn-padrao:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  background-color: #0fafd7 !important;
  color: #fff !important;
}
</style>
